module.exports = __webpack_public_path__ + "img/art-work-icon4.82937b3a.png";